import React, { PureComponent } from "react";
import classNames from "classnames";
import "./button.css";
/**
 * @author chargoyao
 * @description button component
 * @property title
 * @property className
 * @property disabled {boolean}
 * @property ifHasBg {boolean} if false color will be white and border color is black
 * @method handleClick
 */
class Button extends PureComponent {
  static defaultProps = {
    ifHasBg: true,
    disabled: false,
  };
  handleClick(e) {
    this.props.handleClick(e);
  }
  render() {
    const { className } = this.props;
    return (
      <button
        disabled={this.props.disabled}
        className={classNames("aw-btn", className)}
        style={{
          color: !this.props.ifHasBg ? "black" : "",
          border: !this.props.ifHasBg ? "1px solid black" : "",
          background: !this.props.ifHasBg ? "white" : "",
        }}
        onClick={e => this.handleClick(e)}
      >
        {this.props.title}
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/framework/Button/Button.jsx